<template>
  <a-modal :visible="showModal" :title="showEdit ? '新建笔记' : '编辑笔记'" :width="1000" @cancel="modalClose">
    <template slot="footer">
      <a-button key="back" @click="modalClose"> 取消 </a-button>
      <a-button key="submit" type="primary" @click="handleOK" :loading="createLoading"> 确认 </a-button>
    </template>
    <a-form :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-item label="笔记名称" :help="notesNameHelp" :validate-status="notesNameStatus">
        <a-input
          placeholder="请输入笔记名称"
          v-model="notesName"
          @change="changeNotesName"
          style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="标签" :help="notesTagHelp" :validate-status="notesTagStatus">
        <a-select
          ref="tag_select"
          mode="tags"
          v-model="noteTags"
          @search="handleTagSearch"
          @change="changeNotesTag"
          placeholder="请选择笔记的标签，可自定义输入，按Enter键生成自定义选项"
        >
          <a-select-option v-for="tag in tagOption" :key="tag.tag">
            {{ tag.tag }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="摘要" :help="notesSummaryHelp" :validate-status="notesSummaryStatus">
        <a-textarea placeholder="请输入笔记摘要（200个字以内）" :auto-size="{ minRows: 3, maxRows: 5 }" v-model="notesDescription" :maxLength="200"/>
      </a-form-item>
      <a-form-item label="可见性">
        <a-radio-group v-model="notesVisibility">
          <a-radio value="public"> 公开（发布至SQL仓库） </a-radio>
          <a-radio value="private"> 私密（仅我的笔记可见）</a-radio>
        </a-radio-group>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { createNotesApi, notesTagsApi, modifyNotesApi } from '@/api/notes'
export default {
  name: 'CreateNote',
  props: {
    showEdit: {
      type: Boolean,
      default: false,
    },
    showModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      noteInfo: undefined,
      createLoading: false,
      notesName: '',
      notesDescription: '',
      notesNameStatus: 'success',
      notesTagStatus: 'success',
      notesVisibility: 'private',
      noteTags: [],
      tagOption: [],
      noteContent: '',
      searchPagination: {
        pageNo: 0,
        pageSize: 50,
        search: '',
      },
    }
  },
  watch: {
    noteInfo: {
      immediate: true,
      deep: true,
      handler: function (val) {
        if (!val) return
        this.notesName = val.title
        this.notesDescription = val.summary
        this.notesVisibility = val.visibility
        this.noteTags = val.tag
      },
    },
    showModal(val) {
      if (val) {
        this.$nextTick(() => {
          if (this.$refs.tag_select) {
            let input = this.$refs.tag_select.$el.querySelectorAll('input')[0]
            input.maxLength = 30
          }
        })
      }
    },
  },
  computed: {
    notesNameHelp() {
      return this.notesNameStatus === 'success' ? '' : '请输入笔记名称（4 ~ 40个字以内）'
    },
    notesTagHelp() {
      return this.notesTagStatus === 'success' ? '' : '标签最长支持30字符，数量最多10个'
    },
    notesSummaryHelp() {
      return this.notesSummaryStatus === 'success' ? '' : '请输入笔记摘要（200个字以内）'
    },
    notesSummaryStatus() {
      if (this.notesDescription) {
        return this.notesDescription.length > 200 ? 'error' : 'success'
      } else {
        return 'success'
      }
    },
  },
  mounted() {
    this.getTags()
  },
  methods: {
    handleTagSearch(val) {
      this.searchPagination.pageNo = 0
      this.tagOption = []
      this.getTags(val)
    },
    getTags(val) {
      this.searchPagination.pageNo++
      if (val) {
        this.searchPagination.search = { tag: val }
      } else {
        this.searchPagination.search = { tag: '' }
      }
      notesTagsApi(this.searchPagination)
        .then((res) => {
          this.tagOption = this.tagOption.concat(res.content.data)
        })
        .catch((res) => {
          console.log('获取tag失败：' + res.response.data.msg)
        })
    },
    changeNotesName(val) {
      if (!val?.target?.value) {
        this.notesNameStatus = 'error'
        return
      }
      let length = val.target.value.trim().length
      if (length > 40 || length < 4) {
        this.notesNameStatus = 'error'
        return
      }
      this.notesNameStatus = 'success'
    },
    changeNotesTag(val) {
      if (val?.length > 10) {
        this.notesTagStatus = 'error'
        return
      }
      for (let i = 0; i < val.length; i++) {
        if (val[i].length > 30) {
          this.notesTagStatus = 'error'
          return
        }
      }
      this.notesTagStatus = 'success'
    },
    modalClose() {
      this.$emit('close')
      this.notesName = ''
      this.notesDescription = ''
      this.notesNameStatus = 'success'
      this.notesTagStatus = 'success'
      this.notesVisibility = 'private'
      this.noteTags = []
      this.createLoading = false
    },
    handleOK() {
      if (
        this.notesNameStatus != 'success' ||
        this.notesSummaryStatus != 'success' ||
        this.notesTagStatus != 'success'
      ) {
        return
      }
      this.createLoading = true
      let formData = new FormData()
      formData.append('title', this.notesName)
      formData.append('noteType', 'markdown')
      if (this.noteTags.length != 0) {
        let tag = { tag: this.noteTags }
        formData.append('tag', JSON.stringify(tag))
      }
      formData.append('summary', this.notesDescription)
      formData.append('visibility', this.notesVisibility)
      if (this.noteContent) {
        var blob = new Blob([this.noteContent], { type: 'application/octet-stream' })
        var file = new File([blob], this.notesName + '.md', { type: 'text/plain' })
        formData.append('file', file)
      }
      if (this.showEdit) {
        createNotesApi(formData)
          .then((res) => {
            this.modalClose()
            if (this.showEdit) {
              this.showEditMessgage(res.content.uid)
            }
          })
          .catch((res) => {
            this.createLoading = false
            this.$message.error('笔记创建失败：' + res.response.data.msg)
          })
      } else {
        modifyNotesApi({ noteId: this.noteInfo.uid }, formData)
          .then((res) => {
            this.modalClose()
            this.$message.success('笔记修改成功！')
          })
          .catch((res) => {
            this.$message.error('笔记修改失败：' + res.response.data.msg)
            this.saveLoading = false
          })
      }
    },
    showEditMessgage(uid) {
      const _this = this
      this.$confirm({
        title: '提示',
        content: '立即编辑笔记？',
        okText: '确定',
        cancelText: '取消',
        centered: true,
        maskClosable: true,
        onOk() {
          localStorage.setItem('CURRENT_NOTE_ID', uid)
          _this.$store.commit('SET_NOTE_ID', uid)
          _this.$emit('edit', uid)
        },
      })
    },
  },
}
</script>
<style lang="less" scoped>
</style>